import React, { Component } from 'react'; 
import {Row , Col, Button, Spinner } from 'react-bootstrap';
import _ from 'lodash';
import { connect } from 'react-redux';
import {InventoryUserMappedAction, TokenValidation} from '../Dashboard/UserActions';
import {SamplingMappedListAction} from '../Sampling/SamplingAction';
import {DocumentNames, fileUploadMapping, resetScreenMessage, closeModalPopUp} from './fileUploadAction'
import Picky from 'react-picky';
import ShowModalPopUp from '../ShowModalPopUp';
import 'react-picky/dist/picky.css'; // Include CSS


class FileUpload extends Component {
  constructor(props){
    super(props)
    this.state= this.getinitialState()    
    }
   getinitialState(){
    return {
      selectedregionName:[],
      selectedcenterName:[],
      selectedclientName:[],
      selectedprocessName:[],
      inputFiles:[],
      documentsLoad:[{}],
      load:false ,
      selectedDocumentName0: null,
      selectedDocumentName1: null,  
      disableaddingMore:false
    };
  }
  componentWillMount = () => {  
    this.props.actioninventoryUserMapped()
    this.props.mappingAction()
    this.props.documents()
    this.props.resetScreenMessage()        
  }
  UNSAFE_componentWillReceiveProps(nextProps){
    if(!_.isEqual(nextProps.showModalLogin, this.props.showModalLogin) && nextProps.showModalLogin === false){     
      this.props.actioninventoryUserMapped()
      this.props.documents()  
    }
  }     
  regionNames = () => {
    const{inventory} = this.props;  
    if(!_.isEmpty(inventory)){
    let regionNames = _.filter(inventory); 
    return regionNames;
    }    
  }
  centerNames = () => {
    const{selectedregionName} = this.state;
    const{inventory} = this.props;
    if(!_.isEmpty(inventory) && typeof selectedregionName !== 'undefined'){
        let centerName = _.filter(selectedregionName.userCenters);
      return centerName;
    }
  }
  clientNames = () =>{
    const{selectedcenterName} = this.state;
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){
        let clientName = _.filter(selectedcenterName.userClients);
        clientName = _.uniqBy(clientName, 'inventoryClientId');
    return clientName;
    }
  }
  processNames = () => {
    const{selectedclientName} = this.state;
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){
        let processName = _.filter(selectedclientName.userProcesses);
        processName = _.uniqBy(processName, 'inventoryProcessId');
    return processName;
    }
  }  
  
  handleSelect = (e) => {
    this.setState({selectedregionName: e} );
    if(!_.isEqual(this.state.selectedregionName, e)){
      this.setState({selectedcenterName:[], selectedclientName:[], selectedprocessName:[],
        inputFiles:[],  documentsLoad:[{}]})
      this.fileInput.value=""
      this.props.resetScreenMessage()
    }
  }
  handleSelectCenter = (e) => {
    this.setState({selectedcenterName: e});
    if(!_.isEqual(this.state.selectedcenterName, e)){
      this.setState({ selectedclientName:[], selectedprocessName:[],
        inputFiles:[],  documentsLoad:[{}]})
      this.fileInput.value=""
      this.props.resetScreenMessage()
    }
  }
  handleSelectClient = (e) => {
    this.setState({selectedclientName: e});
    if(!_.isEqual(this.state.selectedclientName, e)){
      this.setState({selectedprocessName:[], inputFiles:[],
        documentsLoad:[{}]})
      this.fileInput.value=""
      this.props.resetScreenMessage()
    }
  }
  handleSelectProcess = (e) => {
      this.setState({selectedprocessName: e})
      if(!_.isEqual(this.state.selectedprocessName, e)){
        this.setState({inputFiles:[],documentsLoad:[{}]})
        this.fileInput.value=""
        this.props.resetScreenMessage()
      }
      
  }
   
  duplicateItem = () =>{
    const{documentsLoad} = this.state;
//    let index = this.props.documentload.documents.length
    if(documentsLoad.length < 2){
      let newrow = _.cloneDeep(this.state.documentsLoad[0])
      this.state.documentsLoad.push(newrow)
      this.setState({documentsLoad}) 
    }
  }
  loadDocuments = () =>{
    if(!_.isEmpty(this.props.documentload)){
      let obj = _.cloneDeep(this.props.documentload.documents) 
        obj = _.pullAllBy(obj, this.state.documentsLoad)
      return obj;
    }
  }
  handleSelectDocuments = (obj, i ) => {
    const{documentsLoad} = this.state;
    this.setState({['selectedDocumentName'+i]:obj })
    documentsLoad[i] = obj
    if(obj === 'Mapping Sheet'){
      this.setState({disableaddingMore:true})
    } else {
      this.setState({disableaddingMore:false})
    }
    this.setState({documentsLoad})
  }  
  filehandler = (e, i) => {
    const{inputFiles} = this.state;
    if(!_.isNull(e.target.files[0])){
    inputFiles[i] = e.target.files[0]   
    let fileSize = e.target.files[0].size /1024 
    if (fileSize >= 5120) { 
       alert( 
         "File too Big, Please select a file less than equal to 5mb"); 
      e.target.value =""
    } else {
       inputFiles[i] = e.target.files[0]         
       this.setState({inputFiles})  
      
    }
  }
    //this.setState({inputFiles})    
  }
  validateForm = () =>{  
    const {selectedclientName,selectedcenterName, selectedregionName, selectedprocessName, documentsLoad, inputFiles} = this.state;
    let valid;    
      if(_.includes(documentsLoad, "CRM")){
        if(_.includes(documentsLoad, "CLI") && (documentsLoad.length === inputFiles.length) ){
          valid = true
        } else {
          valid = false
        }
      } else if(_.includes(documentsLoad, "CLI")) {
        if(_.includes(documentsLoad, "CRM") && (documentsLoad.length === inputFiles.length)){
          valid = true
       } else {
        valid = false
       }
    }  else {
      if(!_.isEmpty(inputFiles) && (documentsLoad.length === inputFiles.length)){
        valid = true
      }
    }
      if(!_.isEmpty(selectedcenterName) && !_.isEmpty(selectedclientName) && !_.isEmpty(selectedregionName) && (valid === true)
      && !_.isEmpty(selectedprocessName)  && _.isEmpty(this.props.screenMessage) && this.props.isPending === false){
        return true }
  }
  SaveTemplate= () => {   
    const {selectedregionName,selectedcenterName,selectedclientName, selectedprocessName, documentsLoad, inputFiles} = this.state;    
    let temp = {
    "regionId":selectedregionName.inventoryRegionId,
    "regionName":selectedregionName.inventoryRegionName,
    "centerId": selectedcenterName.inventoryCenterId,
    "centerName":selectedcenterName.inventoryCenterName,
    "clientId":selectedclientName.inventoryClientId,
    "clientName":selectedclientName.inventoryClientName,
    "processId": selectedprocessName.inventoryProcessId,
    "processName":selectedprocessName.inventoryProcessName,
    "documents": documentsLoad,   
    'userId':this.props.loginAction.userName,
    'email':this.props.loginAction.email
   }
    const formData = new FormData()
    
    inputFiles.map((file, index) => {
      formData.append('MultipartFile', file);
      return null;
    });
    
    formData.append('inputRecordJson', JSON.stringify(temp))
    this.props.TokenValidation()    
    this.props.fileUploadMap(formData)  
    
  }
  resetTemplate = () => {
    this.fileInput.value=""
    this.setState(this.getinitialState())
    this.props.resetScreenMessage()
  }
  
  render(){  
    let style= true
		if(typeof this.props.size !== 'undefined'){
			style = this.props.size
		}  
    return(
    <div  className={(style) ? 'user' : "userSmall"}>
    <div className='margingap inventory'>
    {this.props.isPending === true ? <p className='spinner'><Spinner animation="grow" role="status" size='lg'/>
        Loading...</p> : null}
    {(this.props.showerror === true) ?
        <ShowModalPopUp message={this.props.errmessage} 
        falseShowModalPopUp={this.props.closeModalPopUp}/> : null}
     <Row className='clearBoth'>
       <Col>
         <label>Region Name</label>
       </Col>
       <Col>
       <Picky keepOpen={false}
         value={this.state.selectedregionName}
         options={this.regionNames()}
         onChange={this.handleSelect}
         open={false}
         valueKey="inventoryRegionName"
         labelKey="inventoryRegionName"
         multiple={false}
         includeSelectAll={false}
         includeFilter={true}
				 clearFilterOnClose={true}
         placeholder='Select Region'
         dropdownHeight={600}
       />
       </Col>
     </Row> 
    
     <Row>
       <Col>
         <label>Center Name</label>
       </Col>
       <Col>
       <Picky keepOpen={false}
         value={this.state.selectedcenterName}
         options={this.centerNames()}
         onChange={this.handleSelectCenter}
         open={false}
         valueKey="inventoryCenterName"
         labelKey="inventoryCenterName"
         multiple={false}
         includeSelectAll={false}
         includeFilter={true}
				 clearFilterOnClose={true}
         placeholder='Select Center'
         dropdownHeight={600}
       />
       </Col>             
     </Row>
    
     <Row>
     <Col>
     <label>Client Name</label>
     </Col>
     <Col>
     <Picky keepOpen={false}
       value={this.state.selectedclientName}
       options={this.clientNames()}
       onChange={this.handleSelectClient}
       open={false}
       valueKey="inventoryClientName"
       labelKey="inventoryClientName"
       multiple={false}
       includeSelectAll={false}
       includeFilter={true}
       clearFilterOnClose={true}
       placeholder='Select Client'
       dropdownHeight={600}
     />
     </Col>
     </Row> 
     
     <Row>
      <Col>
      <label>Process Name</label>
      </Col>
      <Col>
     <Picky keepOpen={false}
       value={this.state.selectedprocessName}
       options={this.processNames()}
       onChange={this.handleSelectProcess}
       open={false}
       valueKey="inventoryProcessName"
       labelKey="inventoryProcessName"
       multiple={false}
       includeSelectAll={false}
       includeFilter={true}
       clearFilterOnClose={true}
       placeholder='Select Process Name'
       dropdownHeight={600}
     />
      </Col>
     </Row>
     {
      _.map(this.state.documentsLoad, (x, i) =>{
        return(
        <Row key={i}>
        <Col md={6}>
       { i===0 ?  <label>Document Name</label> : null}
        </Col>
        <Col>
        <Picky keepOpen={false}
        value={this.state['selectedDocumentName'+i]}
        options={this.loadDocuments()}
        onChange={(e)=>this.handleSelectDocuments(e, i)}
        open={false}
        multiple={false}
        includeSelectAll={false}
        includeFilter={false}
        placeholder='Select Documents'
        dropdownHeight={600}
        />
        </Col>
        <Col>
        {/* <form  method="post" enctype="multipart/form-data"> */}
          <input id={i} type='file' ref={(i === 0) ?
            ref=> this.fileInput = ref   : null}           
          onChange={(e)=>this.filehandler(e, i)} /> 
       {/* // </form> */}

        {this.state.disableaddingMore === true ? null :
        <i className='fas fa-plus-circle accord' onClick={this.duplicateItem}/>
        }
        </Col>
            
        </Row>
        )
      })
    }    
    <br/>
    
    <center>
      <h5  className="RedColoring">{this.props.screenMessage}</h5> 
      <Button onClick={this.SaveTemplate} 
      className='buttonwidth' 
      disabled={!this.validateForm()}
      >
        Upload</Button>&nbsp;
      <Button onClick={this.resetTemplate} 
      className='buttonwidth'>Reset</Button>
      
      
      </center>
    
    </div>
    </div>)
   }
  }    

  function mapStateToProps(state){
    return{
     inventory: state.UserReducer.inventoryMapped,
     size: state.UserReducer.large,
     documentload: state.fileUploadReducer.result,     
     showerror:  state.fileUploadReducer.showerror, 
     errmessage:  state.fileUploadReducer.errmessage,
     showModalLogin: state.UserReducer.showModalLogin,
     loginAction: state.LoginReducer.loginAction,
     mappedData: state.SamplingReducer.mappedData,
     isPending: state.fileUploadReducer.isPending,
     screenMessage:state.fileUploadReducer.screenMessage
    }  
  }
  
  const mapDispatchToProps = (dispatch) => ({
    actioninventoryUserMapped:  () =>dispatch(InventoryUserMappedAction()),
    documents:  () =>dispatch(DocumentNames()),
    mappingAction:  () =>dispatch(SamplingMappedListAction()),
    fileUploadMap: (a) =>dispatch(fileUploadMapping(a)),
    closeModalPopUp:  (a) =>dispatch(closeModalPopUp(a)), 
    TokenValidation : (a) => dispatch(TokenValidation(a)),
    resetScreenMessage: () => dispatch(resetScreenMessage())
  })
  export default connect(mapStateToProps, mapDispatchToProps)(FileUpload);


  